export default __webpack_public_path__ + "static/media/hybrid.354648b4.svg";